
    export function _writeText(value) {
        navigator.clipboard.writeText(value);
    }
